(function () {
    'use strict';

    angular.module("imApp").factory("prodGrp2Service", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3070,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3071,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 3073,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();